<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div
          v-if="status==='own_request_other_profile' || status==='own_company_other_user' || status==='own_request_other_company'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizSorunuYaradanIrktinMkdasnzZTmsilEtdiyinizIrktin') }}
          </div>
        </div>
        <div
          v-else-if="status==='co_worker'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizSorununNzartisisinizNzartisisiOlduunuzSoruyaTkl') }}
          </div>
        </div>
        <div
          v-else-if="status==='not_active_request'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.soruyaTkliflrinQbuluNTyinEdilmiMddtBitibSorununNti') }}
          </div>
        </div>
        <div
          v-else-if="status==='company_not_approved'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.irktinizinMlumatlarTsdiqlnmyib') }}
          </div>
          <div>
            <button
              class="btn btn-warning"
              @click.prevent="openSupport"
            >
              {{ $t('sidebar.dstk') }}
            </button>
          </div>
        </div>
        <div
          v-else-if="status==='user_not_verified'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.soruVernIrktSoruyaYalnzTsdiqliIrktlrinTklifVermsin') }}
          </div>
          <div>
            <router-link
              class="btn btn-warning"
              :to="{name: 'page', params:{slug: 'admin_guide'}}"
            >
              {{ $t('requestCannotCommentOfferView.tsdiqliIrktOlmaqNMracitEdin') }}
            </router-link>
          </div>
        </div>
        <div
          v-else-if="status==='personal_not_allowed'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.soruSahibiYalnzVeniOlanXslrinTklifGndrmsiniTlbEdir') }}
          </div>
          <div>
            <router-link
              class="btn btn-warning"
              :to="{name: 'changeAccount'}"
            >
              {{ $t('requestCannotCommentOfferView.irktHesabnaKein') }}
            </router-link>
          </div>
        </div>
        <div v-else-if="status==='no_package'">
          <div class="d-flex justify-content-between">
            <div class="text-danger">
              {{ $t('requestCannotCommentOfferView.sorunuCavablayaBilmkNZhmtOlmasaAbunlikPaketiniziSe') }}
            </div>
            <div>
              <router-link
                class="btn btn-warning"
                :to="{name: 'subscriptionPage'}"
              >
                {{ $t('sidebar.abunliyim') }}
              </router-link>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <div class="text-danger">
              {{ $t('requestCannotCommentOfferView.sizSoruVernTkilatnTsdiqliTdarkSiyahsndaOlarsnzsaBu') }}
            </div>
            <div>
              <button
                v-b-modal.modal-company-form
                class="btn btn-sm btn-success"
              >
                {{ $t('requestsByType.tdarkTsdiqFormalar') }}
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="status==='package_not_active'">
          <div class="d-flex justify-content-between">
            <div class="text-danger">
              {{ $t('requestCannotCommentOfferView.abunlikMddtiBitibVYaDayandrlbPortaldanIstifadEtmkN') }}
            </div>
            <div>
              <router-link
                class="btn btn-warning"
                :to="{name: 'subscriptionPage'}"
              >
                {{ $t('sidebar.abunliyim') }}
              </router-link>
            </div>
          </div>
          <div class="mt-3">
            <div class="text-danger">
              {{ $t('requestCannotCommentOfferView.sizSoruVernTkilatnTsdiqliTdarkSiyahsndaOlarsnzsaBu') }}
            </div>
            <div class="mt-2">
              <button
                v-b-modal.modal-company-form
                class="btn btn-sm btn-success"
              >
                {{ $t('requestsByType.tdarkTsdiqFormalar') }}
              </button>
            </div>
          </div>
        </div>
        <div
          v-else-if="status==='company_blacklisted'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizinIrktinizSoruYaradanIrktinQaraSiyahsndadrHminI') }}
          </div>
        </div>

        <div v-else-if="status==='not_vendor'">
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.soruMllifiYalnzTsdiqlnmiTdarklrdnCavabQbulEdirTmsi') }}
          </div>
          <div class="mt-2">
            <button
              v-b-modal.modal-company-form
              class="btn btn-sm btn-success"
            >
              {{ $t('requestsByType.tdarkTsdiqFormalar') }}
            </button>
          </div>
        </div>

        <div v-else-if="status==='your_vendor_sector_does_not_match'">
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizSoruMllifininBuSektorZrTsdiqliTdarkSiyahsndaDey') }}
          </div>
          <div class="mt-2">
            <button
              v-b-modal.modal-company-form
              class="btn btn-sm btn-success"
            >
              {{ $t('requestsByType.tdarkTsdiqFormalar') }}
            </button>
          </div>
        </div>

        <div
          v-else-if="status==='need_supplier'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.qiymtTklifiVerBilmkNTdarkProfilinizOlmaldr') }}
          </div>
          <div>
            <button
              class="btn btn-sm btn-success"
              @click="goToProfile('SUPPLIER')"
            >
              {{ $t('requestCannotCommentOfferView.tdarkProfilinKe') }}
            </button>
          </div>
        </div>

        <div
          v-else-if="status==='need_logistic'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.qiymtTklifiVerBilmkNLogistikaProfilinizOlmaldr') }}
          </div>
          <div>
            <button
              class="btn btn-sm btn-success"
              @click="goToProfile('LOGISTIC')"
            >
              {{ $t('requestCannotCommentOfferView.logistikProfilinKe') }}
            </button>
          </div>
        </div>

        <div
          v-else-if="status==='need_procurement'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.qiymtTklifiVerBilmkNSatnalmaProfilinizOlmaldr') }}
          </div>
          <div>
            <button
              class="btn btn-sm btn-success"
              @click="goToProfile('PROCUREMENT')"
            >
              {{ $t('requestCannotCommentOfferView.satnalmaProfilinKe') }}
            </button>
          </div>
        </div>

        <div
          v-else-if="status==='need_truck'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.qiymtTklifiVerBilmkNTrSahibiProfilinizOlmaldr') }}
          </div>
          <div>
            <button
              class="btn btn-sm btn-success"
              @click="goToProfile('TRUCK')"
            >
              {{ $t('requestCannotCommentOfferView.trSahibiProfilinKe') }}
            </button>
          </div>
        </div>

        <div
          v-else-if="status==='no_truck'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizTrSahibiProfilindnBuSoruyaCavabYazaBilmzsiniz') }}
          </div>
          <div>
            <router-link
              class="btn btn-warning"
              :to="{name: 'changeAccount'}"
            >
              {{ $t('requestCannotCommentOfferView.profilimiDyi') }}
            </router-link>
          </div>
        </div>

        <div
          v-else-if="status==='company_already_participating'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizinIrktinDigrMkdaArtqBuSorudaItirakEdirSizBuSoru', {companyParticipationUser: companyParticipationUser}) }}
          </div>
        </div>

        <div
          v-else-if="status==='user_already_participating'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizBuSoruraBaqaIrktinAdndanSoruGndrmisizBuSorudaIt') }}
          </div>
        </div>

        <div
          v-else-if="status==='user_blocked'"
          class="d-flex justify-content-between"
        >
          <div class="text-danger">
            {{ $t('requestCannotCommentOfferView.sizinSorudaItiraknzSoruSahibiTrfindnMhdudladrlmdr') }}
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-company-form"
      size="xl"
      centered
      :title="$t('requestsByType.tdarkTsdiqFormalar')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="$emit('refresh')"
    >
      <CompanyForms
        :sectors="topSectors"
        :company-id="request.company.id"
        @openProcurementRating="$emit('openProcurementRating', $event) "
      />
    </b-modal>

    <b-modal
      id="modal-change-account"
      centered
      :hide-footer="true"
      :title="$t('body.profilSeimi')"
      class="theme-modal"
    >
      <ChangeAccountPopup
        :need-profiles="needProfiles"
        :company="company"
      />
    </b-modal>
  </div>
</template>
<script>
import CompanyForms from "@/pages/scc/vendorManagement/supplier/CompanyForms.vue";
import {userSetAccount} from "@/repositories/GeneralDataRepository";
import {getProfileName} from "@/repositories/Utils";
import {mapState} from "vuex";
import ChangeAccountPopup from "@/pages/scc/account/ChangeAccountPopup.vue";

export default {
  name: 'RequestCanNotCommentOfferView',
  components: {ChangeAccountPopup, CompanyForms},
  props: {
    status: {},
    request: {},
    companyParticipationUser: {},
    sectors: {},
  },
  data() {
    return {
      needProfiles: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      company: state => state.auth.company,
    }),
    topSectors() {
      return this.sectors.map((sector) => {
        return this.getParentSector(sector);
      });
    }
  },
  methods: {
    getParentSector(sector) {
      return sector.parent === null ? sector : this.getParentSector(sector.parent);
    },
    goToProfile(profileType) {
      userSetAccount(this.token, this.company.id, profileType, 'company').then((data) => {
        if (data.code === 200) {
          window.location.reload();
        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("sznPrflnzYxdr", {profileType: getProfileName(profileType)}),
            icon: 'warning'
          }).then(() => {
            this.needProfiles = [profileType];
            this.$bvModal.show('modal-change-account');
          });
        }
      });
    },

    openSupport() {
      this.$bvModal.show('modal-feedback-form');
    },

  }
}
</script>
